
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { CustomerSpecificationTypeEntity } from '../entities/customerSpecificationType.entity';
import { State } from '../State';
import { getCustomerSpecificationTypes } from '../State/selectors/customerSpecificationType.selectors';
import { CustomerSpecificationTypeActionTypes } from '../State/actions/customerSpecificationType.actions';

@Injectable({
  providedIn: 'root'
})
export class CustomerSpecificationTypeResolver implements Resolve<CustomerSpecificationTypeEntity[]> {
  constructor(private store: Store<State>) {
  }

  resolve() {
    const value$ = this.store.select(getCustomerSpecificationTypes);

    value$
      .pipe(
        filter(value => !value),
        take(1),
        tap(() => {
          if (localStorage.getItem('token') != null) {
            this.store.dispatch(CustomerSpecificationTypeActionTypes.GetCustomerSpecificationTypeRequest());
          }
        })
      )
      .subscribe();

    return value$.pipe(
      filter(value => !!value),
      take(1)
    );
  }
}
